import { cn } from '../../lib/cn';
import type { UnifiedOpRow } from '../../unifiedcommerce/framework';

type Props = { operations?: UnifiedOpRow[] };

export function UnifiedOperationsPanel({ operations = [] }: Props) {
  return (
    <div className="space-y-2">
      {operations.map((o) => (
        <div key={o.operation} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{o.operation}</p>
            <p className="mt-0.5 text-xs text-slate-500">{o.records.toLocaleString()} records · {o.channels} channels</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            o.status === 'live' ? 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300' :
            'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300',
          )}>
            {o.status}
          </span>
        </div>
      ))}
    </div>
  );
}
